<template>
	<footer class="footer" :class="{ footer_home: $route.path === '/' }">
		<div class="footer__inner _cnt">
			<nav class="footer__nav nav">
				<ul class="nav__list">
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{ nav__link_active: $route.path === '/' }"
							to="/"
							>{{ $t('Home') }}</router-link
						>
					</li>
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{
								nav__link_active: $route.path === '/products/all',
							}"
							:to="{
								name: 'ProductListPage',
								params: { itemType: 'all' },
							}"
							>{{ $t('Shop') }}</router-link
						>
					</li>
					<li class="nav__item">
						<router-link
							to="/contact-us"
							class="nav__link _header-link"
							:class="{
								nav__link_active: $route.path === '/contact-us',
							}"
							>{{ $t('Contact us') }}</router-link
						>
					</li>
				</ul>
				<div v-if="paymentMethodsList.length" class="nav__payment-methods">
					<div
						v-for="method in paymentMethodsList"
						:key="method.code"
						class="nav__payment-method _ibg-contain"
					>
						<img :src="method.image" :alt="method.title" />
					</div>
				</div>
				<template v-else>
					<div class="nav__payment-methods">
						<div class="nav__payment-method _ibg-contain">
							<img src="@/assets/img/payment-methods/visa.svg" />
						</div>
						<div class="nav__payment-method _ibg-contain">
							<img src="@/assets/img/payment-methods/mastercard.svg" />
						</div>
					</div>
				</template>
			</nav>
			<div class="footer__middle middle">
				<router-link to="/" class="middle__logo _ibg-contain">
					<img src="@/assets/images/icons/footer-logo.svg" />
				</router-link>
				<div class="middle__items">
					<router-link
						v-for="page in staticPages"
						:key="page.id"
						:to="{ name: 'TextPage', params: { slug: page.slug } }"
						class="middle__item"
					>
						<span>{{ page.title }}</span>
					</router-link>
				</div>
			</div>
			<div class="footer__about about">
				<a :href="`mailto:${footerSupportEmail}`" class="about__email">{{
					footerSupportEmail
				}}</a>
				<div
					v-if="
						requisitesParts.first ||
						requisitesParts.second ||
						requisitesParts.third
					"
					class="about__items"
				>
					<div v-if="requisitesParts.first" class="about__item">
						<div class="about__item-name">{{ $t('Company Name') }}:</div>
						<div class="about__item-value">
							{{ requisitesParts.first }}
						</div>
					</div>
					<div v-if="requisitesParts.second" class="about__item">
						<div class="about__item-name">{{ $t('Reg. Number') }}:</div>
						<div class="about__item-value">
							{{ requisitesParts.second }}
						</div>
					</div>
					<div v-if="requisitesParts.third" class="about__item">
						<div class="about__item-name">{{ $t('Legal Address') }}:</div>
						<div class="about__item-value">
							{{ requisitesParts.third }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import {
	COOKIE_PAGE,
	PRIVACY_PAGE,
	TERMS_PAGE,
} from '@/store/modules/staticPages';
import { mapState } from 'vuex';

export default {
	name: 'FooterComponent',
	props: {
		footerRequisites: {
			type: String,
		},
		footerSupportEmail: {
			type: String,
			required: true,
		},
		footerCopyright: {
			type: String,
			default: '',
		},
		paymentMethods: {
			type: [Object, Array],
		},
		isAuth: {
			type: Boolean,
		},
	},
	data() {
		return {
			socials: [],
		};
	},
	computed: {
		...mapState('staticPages', ['pages']),
		staticPages() {
			return this.pages || [];
		},
		paymentMethodsList() {
			if (!this.paymentMethods) return [];
			return this.paymentMethods;
		},
		requisitesParts() {
			const text =
				typeof this.footerRequisites === 'string'
					? this.footerRequisites
					: '';

			if (!text.trim()) {
				return {
					first: '',
					second: '',
					third: '',
				};
			}

			const parts = text
				.split('\n')
				.map((p) => p.trim())
				.filter(Boolean);

			return {
				first: parts[0] || '',
				second: parts[1] || '',
				third: parts[2] || '',
			};
		},
	},
	created() {
		// Make constants available in template
		this.TERMS_PAGE = TERMS_PAGE;
		this.PRIVACY_PAGE = PRIVACY_PAGE;
		this.COOKIE_PAGE = COOKIE_PAGE;
	},
	mounted() {
		this.getSocials();
		console.log('staticPages', this.staticPages);
	},
	methods: {
		//getDefaultSocials() {
		//	return [
		//		{
		//			title: 'Facebook',
		//			link: 'https://www.facebook.com/',
		//			img: require('@/assets/img/face.svg'),
		//		},
		//		{
		//			title: 'Instagram',
		//			link: 'https://www.instagram.com/',
		//			img: require('@/assets/img/inst.svg'),
		//		},
		//	];
		//},
		sellSkin() {
			if (this.isAuth) {
				this.$emit('openSellSkinModal');
			} else {
				this.$emit('openSignIn');
			}
		},
		handleShopNowClick() {
			if (this.isAuth) {
				this.$router.push('/products/all');
			} else {
				this.$emit('openSignIn');
			}
		},
		getPageType(page) {
			if (page.is_terms === 1) return TERMS_PAGE;
			if (page.is_privacy === 1) return PRIVACY_PAGE;
			if (page.is_cookie === 1) return COOKIE_PAGE;
			return null;
		},
		// getImages(method) {
		//   const images = [];
		//   if (method.code === "card" || method.title === "Visa/Mastercard") {
		//     images.push(
		//       require("@/assets/img/methods/visa.svg"),
		//       require("@/assets/img/methods/mc_symbol.svg")
		//     );
		//   } else if (method.code === "eps" || method.title === "EPS") {
		//     images.push(require("@/assets/img/methods/eps.svg"));
		//   } else if (method.code === "trustly" || method.title === "Trustly") {
		//     images.push(require("@/assets/img/methods/trustly.svg"));
		//   } else if (method.code === "giropay" || method.title === "GiroPay") {
		//     images.push(require("@/assets/img/methods/giropay.svg"));
		//   } else if (method.code === "blik" || method.title === "Blik") {
		//     images.push(require("@/assets/img/methods/blik.svg"));
		//   } else if (method.code === "paidby" || method.title === "Paidby") {
		//     images.push(require("@/assets/img/methods/paidby.svg"));
		//   } else if (method.code === "klarna" || method.title === "Klarna") {
		//     images.push(require("@/assets/img/methods/klarna.svg"));
		//   } else if (
		//     method.code === "sofortuberweisung" ||
		//     method.title === "Sofortuberweisung"
		//   ) {
		//     images.push(require("@/assets/img/methods/sofortuber.svg"));
		//   } else if (method.code === "ideal" || method.title === "iDEAL") {
		//     images.push(require("@/assets/img/methods/ideal.svg"));
		//   } else if (
		//     method.code === "bancontact" ||
		//     method.title === "Bancontact"
		//   ) {
		//     images.push(require("@/assets/img/methods/bancontact.svg"));
		//   }
		//   return images;
		// },
		getSocials() {
			this.$http
				.get(process.env.VUE_APP_API + 'social-links')
				.then((res) => {
					const payload = res?.data?.payload || [];
					if (Array.isArray(payload) && payload.length) {
						this.socials = payload;
					}
				})
				.catch(() => {});
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.footer {
	@include adaptiveValue('padding-bottom', 10, 30);
	background-color: var(--bg-primary-color);
	&_home {
		@media (min-width: $md2) {
			@include adaptiveValue('margin-left', 280, 140, 1920, 992, 1);
			@include adaptiveValue('padding-left', 95, 0, 1920, 992, 1);
		}
		.footer__inner {
			max-width: 1950px;
		}
	}
	&__inner {
		display: flex;
		gap: 20px;
		@media (max-width: $md2) {
			flex-wrap: wrap;
			column-gap: 20px;
			row-gap: 25px;
		}
	}
	&__nav {
		flex: 0 1 25%;
		@media (max-width: $md2) {
			order: 2;
			flex: 0 1 calc(50% - 10px);
		}
		@media (max-width: $md4) {
			flex: 1 1 100%;
		}
	}

	&__middle {
		flex: 0 1 50%;
		@media (max-width: $md2) {
			order: 1;
			flex: 1 1 100%;
		}
	}
	&__about {
		flex: 0 1 25%;
		@media (max-width: $md2) {
			order: 3;
			flex: 0 1 calc(50% - 10px);
		}
		@media (max-width: $md4) {
			flex: 1 1 100%;
		}
	}
}

.nav {
	&__list {
		&:not(:last-child) {
			margin-bottom: 10px;
		}
		@media (max-width: $md4) {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
		}
	}
	&__item {
		@media (max-width: $md4) {
			display: inline-block;
			width: fit-content;
		}
	}
	&__link {
		font-size: 16px;
		line-height: 150%;
		font-family: var(--font-family-inter);
		font-weight: 500;
		text-transform: uppercase;
		width: fit-content;
		display: inline-block;
		padding: 10px 0px;
		transition: color 0.3s ease 0s;
		color: var(--primary-color);
		border-bottom: 1px solid transparent;
		pointer-events: auto;
		transition: all 0.3s ease 0s;
		&_active {
			pointer-events: none;
			border-bottom: 1px solid var(--hint-color);
		}
		@media (any-hover: hover) {
			&:hover {
				color: var(--hint-color);
			}
		}
		@media (max-width: $md4) {
			padding: 10px;
		}
	}
	&__payment-methods {
		display: flex;
		gap: 20px;
		@media (max-width: $md4) {
			justify-content: center;
		}
	}
	&__payment-method {
		min-width: 55px;
		width: 55px;
		height: 30px;
	}
}

.middle {
	display: flex;
	flex-direction: column;
	align-items: center;
	&__logo {
		display: inline-block;
		max-width: 400px;
		width: 100%;
		padding-bottom: 20%;
		margin-left: auto;
		margin-right: auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 70, 20, 1920, 1470, 1);
		}
	}
	&__items {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		@include adaptiveValue('gap', 70, 10, 1920, 1470, 1);
	}
	&__item {
		white-space: nowrap;
		font-size: 16px;
		line-height: 150%;
		font-family: var(--font-family-inter);
		font-weight: 500;
		text-transform: capitalize;
		width: fit-content;
		display: inline-block;
		padding: 10px;
		transition: color 0.3s ease 0s;
		color: var(--secondary-color);
		border-bottom: 1px solid transparent;
		pointer-events: auto;
		transition: all 0.3s ease 0s;
		@media (any-hover: hover) {
			&:hover {
				color: var(--primary-color);
			}
		}
		&_active {
			color: var(--primary-color);
			pointer-events: none;
			border-bottom: 1px solid var(--hint-color);
		}
	}
}

.about {
	&__email {
		display: block;
		width: fit-content;
		margin-left: auto;
		color: var(--primary-color);
		font-family: var(--font-family-inter);
		text-transform: lowercase;
		font-weight: 700;
		font-size: 16px;
		line-height: 150%;
		transition: color 0.3s ease 0s;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 15);
		}
		@media (any-hover: hover) {
			&:hover {
				color: var(--hint-color);
			}
		}
	}
	&__items {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
	&__item {
		display: flex;
		gap: 4px;
		@media (max-width: $md1) {
			display: block;
			width: 100%;
			&:not(:last-child) {
				margin-bottom: 8px;
			}
		}
		@media (max-width: $md2) {
			margin-right: auto;
		}
		&-name,
		&-value {
			font-size: 16px;
			font-weight: 500;
			font-family: var(--font-family-inter);
			line-height: 200%;

			@media (max-width: $md1) {
				line-height: 150%;
			}
		}
		&-name {
			white-space: nowrap;
			color: var(--secondary-color);
		}
		&-value {
			color: var(--primary-color);
		}
	}
}
</style>
